import { ValidationSchemaType } from 'hooks/useForm';
import { Company } from '../types/dtos';

export const COUNTRIES = {
    SRB: 'Srbija',
};

export const COMPANY_INITIAL_FIELDS: Company = {
    apartment: '',
    country: COUNTRIES.SRB,
    name: '',
    street: '',
    streetNumber: '',
    floor: '',
    zipCode: '',
    cityId: '',
    vatNumber: '',
    idNumber: '',
    companyOwnerId: null,
};

export const COMPANY_FIELDS_SCHEMA: ValidationSchemaType<Company> = {
    name: {
        required: true,
        maxLength: 100,
    },
    street: {
        required: true,
        maxLength: 100,
    },
    streetNumber: {
        required: true,
        maxLength: 20,
    },
    cityId: {
        required: true,
    },
    zipCode: {
        required: true,
    },
    country: {
        required: true,
    },
    vatNumber: {
        required: true,
        maxLength: 20,
    },
    idNumber: {
        required: true,
    },
};
